export var CONSTRUCTOR_API_KEY = "key_2GToQ7LpD0PIpMo8"; //@TODO: Move to vault

export var SEARCH_SUGGESTION_INDEX_NAME = "Search Suggestions";
export var SEARCH_INPUT_PLACEHOLDER = "Search for products and brands...";